import {
  AssessmentMethodType,
  UpsertDeleteAssessmentEntry,
  UpsertDeleteAssessmentEntryComment,
  UpsertDeleteAssessmentEntryGrade,
  UpsertDeleteAssessmentEntryScore,
} from '@schooly/api';
import { AssessmentEntry } from '@schooly/api';
import { round } from 'lodash';

const isScore = (entry: UpsertDeleteAssessmentEntry): entry is UpsertDeleteAssessmentEntryScore => {
  return entry.method_type === AssessmentMethodType.Score;
};

const isGrade = (entry: UpsertDeleteAssessmentEntry): entry is UpsertDeleteAssessmentEntryGrade => {
  return entry.method_type === AssessmentMethodType.Grade;
};

const isComment = (
  entry: UpsertDeleteAssessmentEntry,
): entry is UpsertDeleteAssessmentEntryComment => {
  return entry.method_type === AssessmentMethodType.Comment;
};

export const convertToAssessmentEntry = (
  entry: UpsertDeleteAssessmentEntry,
): AssessmentEntry | null => {
  const method = {
    id: entry.method_id ?? '',
    type: entry.method_type,
  };

  if (isScore(entry)) {
    return { method, score: entry.score };
  }

  if (isGrade(entry)) {
    return { method, select_list_option_id: entry.select_list_option_id };
  }

  if (isComment(entry)) {
    return {
      method,
      comment: entry.comment,
      creator: {
        relation_id: entry.creator_relation_id,
        title: entry.creator_title ?? null,
        given_name: entry.creator_given_name ?? null,
        last_name: entry.creator_last_name,
        known_as: entry.creator_known_as ?? null,
      },
    };
  }

  return null;
};

export const getScorePercentageValue = (score: number, scoreOutOf: number) => {
  return round((score / scoreOutOf) * 100, 0);
};
